"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const mobx_react_1 = require("mobx-react");
const BreadCrumbNavigation_1 = require("./BreadCrumbNavigation");
let Hero = class Hero extends React.Component {
    render() {
        const backgoundImageUrl = this.props.backgroundImageUrl;
        const hasBackgroundImage = backgoundImageUrl && backgoundImageUrl.length > 0;
        const heading = this.props.heading;
        const ingressText = this.props.ingressText;
        const dimFilter = this.props.dimFilter;
        const link = this.props.link;
        const linkText = this.props.linkText;
        const hasLink = link && linkText;
        const showBreadCrumbNavigation = !(this.props.hideBreadcrumbNavigation);
        let backgroundImageStyle = React.createElement("style", null);
        let dimFilterStyle = {};
        if (hasBackgroundImage) {
            dimFilterStyle.backgroundColor = 'black';
            dimFilterStyle.opacity = 0.25;
            backgroundImageStyle = React.createElement("style", { dangerouslySetInnerHTML: {
                    __html: `@media all and (max-width: 600px) {
                        .product-listing-background-image {
                            background-image: url('${backgoundImageUrl}?width=800&CropMode=percentage&crop=18,0,18,0');
                            background-size: cover;
                            background-repeat: no-repeat;
                        }
                    }
                    @media all and (min-width: 601px) and (max-width: 1024px) {
                        .product-listing-background-image {
                            background: url('${backgoundImageUrl}?width=1024');
                            background-size: cover;
                            background-repeat: no-repeat;
                        }
                    }
                    @media all and (min-width: 1025px) {
                        .product-listing-background-image {
                            background: url('${backgoundImageUrl}?width=1200');
                            background-size: cover;
                            background-repeat: no-repeat;
                        }
                    }`
                } });
            window.addFullWidth();
        }
        else {
            window.removeFullWidth(true);
        }
        return (React.createElement(React.Fragment, null,
            hasBackgroundImage && backgroundImageStyle,
            hasBackgroundImage &&
                React.createElement("div", { className: "row u-pt-6 _sm-u-pt-10 _md-u-pt-17 u-mb-3 u-relative product-listing-background-image" },
                    dimFilter && React.createElement("div", { className: "s-bg-cover background-image", style: dimFilterStyle }),
                    React.createElement("div", { className: "col-lg-12 col-sm-12 col-xs-12 u-z-1" },
                        React.createElement("div", { className: "o-container u-full-width u-mt-2" },
                            showBreadCrumbNavigation && React.createElement(BreadCrumbNavigation_1.default, null),
                            React.createElement("h1", { className: "u-tc s-hero-s s-themecolor-1 u-my-2" }, heading),
                            React.createElement("div", { className: "o-ingress row u-flex-justify--ce u-mt-2" },
                                React.createElement("div", { className: "col-md-6 col-sm-9 col-xs-12 u-tc s-themecolor-1 s-body-text" }, ingressText)),
                            hasLink &&
                                React.createElement("div", { className: "row u-flex-justify--ce u-mt-3" },
                                    React.createElement("a", { className: "o-button", href: link }, linkText)))))));
    }
};
Hero = __decorate([
    mobx_react_1.observer
], Hero);
exports.default = Hero;
